import { getMerchantToken, updateStoredMerchantPermissions } from "./merchantAuthApi";

const API_BASE_URL = (
  process.env.REACT_APP_MERCHANT_API_BASE_URL ||
  "http://secondbite-manage.localhost/merchant-api/v1"
).replace(/\/+$/, "");

const request = async (options = {}) => {
  let response;
  try {
    response = await fetch(`${API_BASE_URL}/role-permissions`, {
      ...options,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${getMerchantToken()}`,
      },
    });
  } catch {
    throw new Error("Unable to connect to the SecondBite backend.");
  }

  const payload = await response.json().catch(() => null);
  if (!response.ok || !payload?.success) {
    const validationMessage = payload?.errors ? Object.values(payload.errors).flat()[0] : null;
    throw new Error(validationMessage || payload?.message || "Unable to load role permissions.");
  }
  return payload.data;
};

export const getMerchantRolePermissions = () => request();
export const saveMerchantRolePermissions = async (permissions) => {
  const data = await request({
    method: "PUT",
    body: JSON.stringify({ permissions }),
  });
  updateStoredMerchantPermissions(data.operator_permissions);
  return data;
};
